import ViewportInterface, { isTopViewMatrix } from './ViewportInterface.js';
import { TopViewViewportTypes } from '../../common/AecModelData.js';

export default class AlignmentServiceViewport extends ViewportInterface {

    constructor(...args) {
        super(...args);

        this.fetchSheetNodeForViewport = this.options.fetchSheetNodeForViewport;
        this.fetch3DNodeForViewport = this.options.fetch3DNodeForViewport;
        this.getModel3DInfoRelatedToViewport = this.options.getModel3DInfoRelatedToViewport;
    }

    getGuid() {
        return this.viewportRaw.regionId;
    }

    isMatrixInLocalCoords() {
        return this.viewportRaw.coordinateSystem?.context?.type === 'Model';
    }

    getViewportBounds() {
        return this.viewportRaw.boundingBox;
    }

    get2DTo3DMatrix() {
        return this.viewportRaw.transform;
    }

    getViewType() {
        return this.viewportRaw.viewType || null;
    }

    getViewOffsets() {
        return this.viewportRaw.viewOffsets || null;
    }

    async getParentSheetNode() {
        if (!this.parentSheetNodePromise) {
            this.parentSheetNodePromise = this.fetchSheetNodeForViewport(this);
        }

        return this.parentSheetNodePromise;
    }

    async get3DNodesForViewport() {
        return this.fetch3DNodeForViewport(this);
    }

    // Returns { versionUrn3D, lineageUrn3D, name3D } for the 3D model related to a viewport
    // Will throw if no model found or has no permissions
    async getRelatedModel3DInfo() {
        return this.getModel3DInfoRelatedToViewport(this);
    }

    findLevelForViewport() {
        if (!this.isTopViewViewport()) {
            return null;
        }

        // Generate synthetic level data.
        return { elevation: this.getElevation() };
    }

    isViewportInLevel(level) {
        if (!this.isTopViewViewport()) {
            return false;
        }

        const z = this.getElevation();

        // Notice that both matrix and level are in world coordinates.
        return z > level.zMin && z < level.zMax;
    }

    supports2DTo3DTransform() {
        return !!this.options.supports2DTo3DTransform;
    }

    isTopViewViewport() {
        const viewType = this.getViewType();
        if (viewType) {
            return TopViewViewportTypes.includes(viewType);
        }

        // Backward compat: angle-based heuristic
        const matrix = this.get2DTo3DMatrix();
        return isTopViewMatrix(matrix);
    }

    isFloorPlan() {

        const viewType = this.getViewType();
        if (viewType) {
            return viewType === 'FloorPlan';
        }

        // Backward compat: assume all top-view manually aligned viewports are floor plans.
        return this.isTopViewViewport();
    }
}
